import React from 'react';

// TranslateContext provides translate function (see Main.js and translator.js)
export const TranslateContext = React.createContext(() => {});
